<template>
  <div>
    <PageSpinner :onloader="onloader" />
    <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
      <router-link to="/dashboard" class="text-white"> Dashboard </router-link>
      <router-link to="/school/examination-and-assessment" class="text-white">
        <i class="fa fa-ellipsis-v px-2"></i>Examination and Assessment
        Management
      </router-link>
      <router-link
        to="/school/examination-and-assessment/cbt-exams"
        class="text-white"
      >
        <i class="fa fa-ellipsis-v px-2"></i>CBT Exams
      </router-link>
      <span class="text-white"
        ><i class="fa fa-ellipsis-v px-2"></i>CBT Exam Answers
      </span>
    </base-header>

    <!--Charts-->
    <div class="container-fluid mt--7">
      <div class="mb-5 mb-xl-0">
        <card header-classes="bg-transparent">
          <modal
            :show.sync="modals.answerDetailsModal"
            modal-classes="modal-dialog-centered modal-lg"
          >
            <div class="answer-details-modal">
              <div class="answer-details-header">
                <div class="answer-details-heading">
                  <span class="answer-details-icon"
                    ><i class="fa fa-clipboard-check"></i
                  ></span>
                  <div>
                    <span class="summary-eyebrow">SUBMISSION REVIEW</span>
                    <h3>Answer details</h3>
                    <p>Review the student’s response for each question.</p>
                  </div>
                </div>
                <div
                  v-if="studentAnswersDetailitem"
                  class="answer-details-header-actions"
                >
                  <span class="detail-question-count">
                    {{ studentAnswersDetailitem.length }}
                    {{
                      studentAnswersDetailitem.length === 1
                        ? "question"
                        : "questions"
                    }}
                  </span>
                  <button
                    class="btn btn-outline-success btn-sm"
                    type="button"
                    :disabled="!studentAnswersDetailitem.length"
                    @click="downloadAnswerDetails"
                  >
                    <i class="fa fa-download"></i> Download
                  </button>
                </div>
              </div>
              <div
                v-if="
                  studentAnswersDetailitem && studentAnswersDetailitem.length
                "
                class="answer-detail-list"
              >
                <article
                  v-for="(item, index) in studentAnswersDetailitem"
                  :key="item.id || index"
                  class="answer-detail-card"
                >
                  <div class="answer-detail-card-heading">
                    <span class="answer-detail-index">{{
                      String(index + 1).padStart(2, "0")
                    }}</span>
                    <div class="answer-detail-question-label">
                      <span>QUESTION {{ index + 1 }}</span>
                      <strong>Response review</strong>
                    </div>
                    <span
                      class="answer-status-pill"
                      :class="
                        isAnswerFailed(item.isAnswer)
                          ? 'answer-status-pill--failed'
                          : 'answer-status-pill--pass'
                      "
                    >
                      <i
                        :class="
                          isAnswerFailed(item.isAnswer)
                            ? 'fa fa-times-circle'
                            : 'fa fa-check-circle'
                        "
                      ></i>
                      {{ isAnswerFailed(item.isAnswer) ? "Failed" : "Pass" }}
                    </span>
                  </div>
                  <div
                    class="answer-detail-field answer-detail-field--question"
                  >
                    <span class="answer-detail-label">Question</span>
                    <div
                      class="answer-detail-value answer-detail-rich"
                      v-html="item.examQuestion"
                    ></div>
                  </div>
                  <div class="answer-detail-response-grid">
                    <div class="answer-detail-field">
                      <span class="answer-detail-label">Selected answer</span>
                      <div
                        class="answer-detail-value answer-detail-rich"
                        v-html="item.questionAnswer || 'No answer selected'"
                      ></div>
                    </div>
                    <div class="answer-detail-field answer-detail-explanation">
                      <span class="answer-detail-label">Answer details</span>
                      <div
                        class="answer-detail-value answer-detail-rich"
                        v-html="
                          item.answerDetails ||
                          'No additional details provided.'
                        "
                      ></div>
                    </div>
                  </div>
                </article>
              </div>
              <div v-else class="answer-details-empty">
                <i class="fa fa-inbox"></i>
                <strong>No answer details available</strong>
                <span>This submission does not contain question details.</span>
              </div>
            </div>
            <template slot="footer">
              <base-button
                type="default"
                @click="modals.answerDetailsModal = false"
                >Cancel</base-button
              >
            </template>
          </modal>
          <div class="row">
            <div class="col-sm-12 col-md-12 col-lg-12">
              <div class="card-body">
                <div v-if="cbtheaderitem" class="exam-summary">
                  <div class="exam-summary-heading">
                    <div>
                      <span class="summary-eyebrow">ASSESSMENT OVERVIEW</span>
                      <h1>Student answers</h1>
                      <p>
                        Review each student’s submission and answer breakdown.
                      </p>
                    </div>
                    <div class="access-code">
                      <span>ACCESS CODE</span>
                      <strong>{{ cbtheaderitem.passCode || "—" }}</strong>
                    </div>
                  </div>
                  <div class="exam-summary-details">
                    <div>
                      <span>Session</span
                      ><strong>{{ cbtheaderitem.schoolSession || "—" }}</strong>
                    </div>
                    <div>
                      <span>Term</span
                      ><strong>{{ cbtheaderitem.schoolTerm || "—" }}</strong>
                    </div>
                    <div>
                      <span>Class</span
                      ><strong>{{ cbtheaderitem.schoolClass || "—" }}</strong>
                    </div>
                    <div>
                      <span>Option</span
                      ><strong>{{ cbtheaderitem.classOption || "—" }}</strong>
                    </div>
                    <div>
                      <span>Questions displayed</span
                      ><strong>{{
                        cbtheaderitem.noofQuestiontoDisplay || "—"
                      }}</strong>
                    </div>
                    <div>
                      <span>Exam duration</span
                      ><strong>{{ cbtheaderitem.examPeriod }} sec</strong>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-12 col-md-12 col-lg-12">
              <div class="card bg-secondary border-0 mb-0">
                <div class="card-body">
                  <div class="answers-section-heading">
                    <div>
                      <h2>Student submissions</h2>
                      <p>
                        Answer counts and attempt dates for this assessment.
                      </p>
                    </div>
                    <div class="answers-section-actions">
                      <span v-if="studentAnswersitem" class="submission-count">
                        {{ studentAnswersitem.length }}
                        {{
                          studentAnswersitem.length === 1
                            ? "submission"
                            : "submissions"
                        }}
                      </span>
                      <button
                        class="btn btn-outline-success btn-sm"
                        type="button"
                        :disabled="
                          !studentAnswersitem || !studentAnswersitem.length
                        "
                        @click="downloadStudentAnswers"
                      >
                        <i class="fa fa-download"></i> Download answers
                      </button>
                    </div>
                  </div>
                  <div
                    v-if="studentAnswersitem && studentAnswersitem.length"
                    class="answer-submission-grid"
                  >
                    <article
                      v-for="item in studentAnswersitem"
                      :key="item.id"
                      class="submission-card"
                    >
                      <div class="submission-card-heading">
                        <span class="student-avatar" aria-hidden="true">
                          {{ studentInitials(item.studentName) }}
                        </span>
                        <div class="submission-student">
                          <h3>{{ item.studentName || "Student" }}</h3>
                          <span>Admission No. {{ item.admNo || "—" }}</span>
                        </div>
                        <div class="time-spent-badge">
                          <i class="fa fa-clock"></i>
                          <span>{{ item.timeSpent || "—" }}</span>
                        </div>
                      </div>

                      <div
                        class="submission-metrics"
                        aria-label="Answer summary"
                      >
                        <div
                          class="submission-metric submission-metric--correct"
                        >
                          <span>Correct</span>
                          <strong>{{ item.correctAnswer }}</strong>
                        </div>
                        <div
                          class="submission-metric submission-metric--incorrect"
                        >
                          <span>Incorrect</span>
                          <strong>{{ item.wrongAnswer }}</strong>
                        </div>
                        <div class="submission-metric submission-metric--total">
                          <span>Total answered</span>
                          <strong>{{ item.totalAnswer }}</strong>
                        </div>
                      </div>

                      <div class="submission-dates">
                        <div>
                          <span><i class="fa fa-play-circle"></i> Started</span>
                          <strong>{{ item.startDateFormatted || "—" }}</strong>
                        </div>
                        <div>
                          <span
                            ><i class="fa fa-flag-checkered"></i> Finished</span
                          >
                          <strong>{{ item.endDateFormatted || "—" }}</strong>
                        </div>
                      </div>

                      <div class="submission-actions">
                        <button
                          class="btn btn-primary"
                          type="button"
                          @click="getQuestionAnswerDetails(item.id)"
                        >
                          <i class="fa fa-eye"></i> View answers
                        </button>
                        <button
                          class="btn btn-outline-secondary"
                          type="button"
                          @click="retakeSchoolExamStudent(item.id)"
                        >
                          <i class="fa fa-redo-alt"></i> Allow retake
                        </button>
                      </div>
                    </article>
                  </div>
                  <div v-else class="submission-empty-state">
                    <span class="submission-empty-icon"
                      ><i class="fa fa-inbox"></i
                    ></span>
                    <strong>{{
                      studentAnswersitem === null
                        ? "Loading student answers..."
                        : "No student submissions yet"
                    }}</strong>
                    <span>{{
                      studentAnswersitem === null
                        ? "Student attempts will appear here when available."
                        : "Student attempts for this exam will appear here."
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </card>
      </div>

      <!-- End charts-->
    </div>
  </div>
</template>

<script>
import moment from "moment";
import * as XLSX from "xlsx";
import Alert from "@/mixins/Alert.mixins";
import PageSpinner from "@/components/PageSpinner";
export default {
  name: "schcbt-answer",
  mixins: [Alert],
  components: {
    PageSpinner,
  },
  data() {
    return {
      accessDetails: null,
      QuestionIdval: localStorage.getItem("SchQuestionId") || "",
      HeaderIdval: localStorage.getItem("SchcbtheaderId") || "",
      cbtquestionitem: null,
      cbtheaderitem: null,
      studentAnswersitem: null,
      studentAnswersDetailitem: null,
      selectedStudentAnswer: null,
      process: "N",
      onloader: "none",
      modals: {
        answerDetailsModal: false,
      },
    };
  },
  methods: {
    downloadStudentAnswers() {
      if (!this.studentAnswersitem || !this.studentAnswersitem.length) return;

      const rows = this.studentAnswersitem.map((item, index) => ({
        "Serial No.": index + 1,
        "Student Name": item.studentName || "",
        "Admission No.": item.admNo || "",
        "Time Spent": item.timeSpent || "",
        "Start Date": item.startDateFormatted || "",
        "End Date": item.endDateFormatted || "",
        Correct: item.correctAnswer,
        Incorrect: item.wrongAnswer,
        "Total Answered": item.totalAnswer,
      }));

      this.downloadWorkbook(
        rows,
        `cbt-student-answers-${this.getExamFilenamePart()}-${this.getExportDate()}.xlsx`,
        "Submissions",
        [12, 28, 18, 15, 22, 22, 12, 12, 16]
      );
    },

    downloadAnswerDetails() {
      if (
        !this.studentAnswersDetailitem ||
        !this.studentAnswersDetailitem.length
      )
        return;

      const student = this.selectedStudentAnswer || {};
      const rows = this.studentAnswersDetailitem.map((item, index) => ({
        "Serial No.": index + 1,
        "Student Name": student.studentName || "",
        "Admission No.": student.admNo || "",
        Question: this.toPlainText(item.examQuestion),
        "Selected Answer": this.toPlainText(item.questionAnswer),
        Result: this.isAnswerFailed(item.isAnswer) ? "Failed" : "Pass",
        "Answer Details": this.toPlainText(item.answerDetails),
      }));

      this.downloadWorkbook(
        rows,
        `cbt-answer-details-${this.getExamFilenamePart()}-${this.getExportDate()}.xlsx`,
        "Answer Details",
        [12, 26, 18, 55, 35, 14, 55]
      );
    },

    downloadWorkbook(rows, filename, sheetName, columnWidths) {
      const worksheet = XLSX.utils.json_to_sheet(rows);
      worksheet["!cols"] = columnWidths.map((width) => ({ wch: width }));
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
      XLSX.writeFile(workbook, filename);
    },

    toPlainText(value) {
      if (value === null || value === undefined) return "";
      const element = document.createElement("div");
      element.innerHTML = String(value);
      return (element.textContent || element.innerText || "").trim();
    },

    getExamFilenamePart() {
      const header = this.cbtheaderitem || {};
      return String(header.passCode || this.HeaderIdval || "exam")
        .trim()
        .replace(/[^a-z0-9-_]+/gi, "-");
    },

    getExportDate() {
      return new Date().toISOString().slice(0, 10);
    },

    studentInitials(name) {
      const parts = String(name || "")
        .trim()
        .split(/\s+/)
        .filter(Boolean);
      return parts.length
        ? parts
            .slice(0, 2)
            .map((part) => part.charAt(0).toUpperCase())
            .join("")
        : "ST";
    },
    isAnswerFailed(value) {
      return value === false || String(value).toLowerCase() === "false";
    },
    getQuestionAnswers() {
      let examHeaderId = this.HeaderIdval;
      this.onloader = "flex";
      this.$store
        .dispatch("SchoolQuestion/GetSchoolExamStudentAnswered", examHeaderId)
        .then((resp) => {
          if (resp.responseCode === "00") {
            this.studentAnswersitem = resp.data;
          }
          this.onloader = "none";
        })
        .catch((err) => {
          this.onloader = "none";
          this.ShowAlertError(err.response.data, "");
        });
    },
    getQuestionHeader() {
      let questionHeaderId = this.HeaderIdval;
      if (questionHeaderId != null) {
        this.onloader = "flex";
        this.$store
          .dispatch(
            "SchoolQuestion/GetByIdSchoolQuestionHeader",
            questionHeaderId
          )
          .then((resp) => {
            if (resp.responseCode === "00") {
              this.cbtheaderitem = resp.data;
            }
            this.onloader = "none";
          })
          .catch((err) => {
            this.onloader = "none";
            this.ShowAlertError(err.response.data, "");
          });
      } else {
        this.$router.push("/school/examination-and-assessment/cbt-exams");
      }
    },
    getQuestionAnswerDetails(studentAnsweredId) {
      this.selectedStudentAnswer =
        this.studentAnswersitem &&
        this.studentAnswersitem.find(
          (item) => String(item.id) === String(studentAnsweredId)
        );
      this.onloader = "flex";
      this.$store
        .dispatch(
          "SchoolQuestion/GetSchoolExamStudentAnsweredDetails",
          studentAnsweredId
        )
        .then((resp) => {
          if (resp.responseCode === "00") {
            this.studentAnswersDetailitem = resp.data;
            this.modals.answerDetailsModal = true;
          }
          this.onloader = "none";
        })
        .catch((err) => {
          this.onloader = "none";
          this.ShowAlertError(err.response.data, "");
        });
    },
    async retakeSchoolExamStudent(studentAnsweredId) {
      const userdata = { studentAnsweredId };
      this.onloader = "flex";
      try {
        const resp = await this.$store.dispatch(
          "SchoolQuestion/RetakeSchoolExamStudent",
          userdata
        );
        this.onloader = "none";

        if (resp.responseCode === "00") {
            this.getQuestionAnswers();
          await this.ShowAlertSuccess(
            resp.responseMessage || "The student can retake this exam.",
            ""
          );
         
        } else {
          await this.ShowAlertError(
            resp.responseMessage || "The retake could not be enabled.",
            ""
          );
        }
      } catch (err) {
        this.onloader = "none";
        const responseData = err.response && err.response.data;
        const message =
          (typeof responseData === "string" && responseData) ||
          (responseData &&
            (responseData.responseMessage || responseData.message)) ||
          err.message ||
          "The retake could not be enabled.";
        await this.ShowAlertError(message, "");
      } finally {
        this.onloader = "none";
      }
    },

    frontEndDateFormat(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    backEndDateFormat(date) {
      return moment(date, "DD/MM/YYYY").format("YYYY-MM-DD");
    },
  },
  mounted() {
    this.accessDetails = this.$store.getters["auth/_user"];
    if (this.accessDetails.isSchoolStaff == false) {
      this.$store.dispatch("auth/Logout");
      this.$router.push("/login");
    } else {
      if (this.$store.state.schooldata.schoolinfo.StatusId == 10) {
        this.$router.push("/tccbtheader");
      } else {
        this.getQuestionHeader();
        this.getQuestionAnswers();
      }
    }
  },
};
</script>

<style scoped>
.answers-table-wrap {
  width: 100%;
  overflow-x: auto;
  border: 1px solid #e9ecef;
  border-radius: 0.65rem;
  background: #fff;
  box-shadow: 0 0.35rem 1rem rgba(50, 50, 93, 0.06);
}

.answers-table-wrap:not(.answers-detail-table-wrap) .answers-table {
  min-width: 680px;
  margin-bottom: 0;
  color: #344767;
}

.answers-table thead {
  background: #f8fafc;
}

.answers-table thead th {
  padding: 0.9rem 0.85rem;
  border-bottom: 1px solid #e9ecef;
  color: #525f7f;
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  white-space: nowrap;
}

.answers-table tbody td {
  padding: 0.95rem 0.85rem;
  border-top: 1px solid #edf0f5;
  vertical-align: middle;
}

.answers-table tbody tr {
  transition: background-color 0.18s ease;
}

.answers-table tbody tr:hover {
  background: #fbfcfe;
}

.answers-detail-table {
  min-width: 0;
  table-layout: fixed;
}

.answers-detail-table th:nth-child(1),
.answers-detail-table td:nth-child(1) {
  width: 36%;
}

.answers-detail-table th:nth-child(2),
.answers-detail-table td:nth-child(2) {
  width: 25%;
}

.answers-detail-table th:nth-child(3),
.answers-detail-table td:nth-child(3) {
  width: 15%;
}

.answers-detail-table th:nth-child(4),
.answers-detail-table td:nth-child(4) {
  width: 24%;
}

.answers-detail-table tbody td {
  overflow-wrap: anywhere;
}

.answers-detail-table .answer-details {
  display: block;
  max-width: 100%;
  background: #f8fafc;
  color: #344767;
  font-weight: 500;
  line-height: 1.45;
  text-align: left;
  white-space: normal;
}

.student-name {
  min-width: 8.5rem;
  color: #172b4d;
  font-weight: 700;
}

.answer-value {
  display: inline-flex;
  min-width: 2rem;
  justify-content: center;
  padding: 0.2rem 0.5rem;
  border-radius: 0.35rem;
  background: #f1f3f5;
  font-weight: 700;
}

.answer-value--correct {
  background: #e8f7ef;
  color: #198754;
}

.answer-value--wrong {
  background: #fff0f0;
  color: #dc3545;
}

.actions-cell {
  text-align: right;
  white-space: nowrap;
}

.actions-cell .btn {
  min-width: 4.5rem;
}

.empty-state {
  padding: 2.5rem 1rem !important;
  color: #8898aa;
  text-align: center;
}

.empty-state i {
  display: block;
  margin-bottom: 0.55rem;
  font-size: 1.5rem;
}

@media (max-width: 767.98px) {
  .answers-table-wrap {
    overflow: visible;
    border: 0;
    background: transparent;
    box-shadow: none;
  }

  .answers-table {
    min-width: 0;
  }

  .answers-table thead {
    display: none;
  }

  .answers-table,
  .answers-table tbody,
  .answers-table tr,
  .answers-table td {
    display: block;
    width: 100%;
  }

  .answers-table tbody tr {
    margin-bottom: 0.85rem;
    border: 1px solid #e9ecef;
    border-radius: 0.65rem;
    background: #fff;
    box-shadow: 0 0.25rem 0.75rem rgba(50, 50, 93, 0.06);
  }

  .answers-table tbody tr:hover {
    background: #fff;
  }

  .answers-table tbody td {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
    padding: 0.7rem 0.85rem;
    border-top: 1px solid #f0f2f5;
    text-align: right;
  }

  .answers-table tbody td:first-child {
    border-top: 0;
  }

  .answers-table tbody td::before {
    color: #8898aa;
    content: attr(data-label);
    font-size: 0.68rem;
    font-weight: 700;
    letter-spacing: 0.04em;
    text-align: left;
    text-transform: uppercase;
  }

  .answers-table tbody td.student-name {
    display: block;
    padding-bottom: 0.85rem;
    color: #172b4d;
    font-size: 1rem;
    text-align: left;
  }

  .answers-table tbody td.student-name::before {
    display: block;
    margin-bottom: 0.25rem;
  }

  .answers-table tbody td.actions-cell {
    text-align: right;
  }

  .answers-table tbody td.actions-cell .btn {
    flex: 0 0 auto;
  }

  .answers-detail-table tbody td {
    align-items: flex-start;
  }

  .answers-detail-table tbody td:not(.student-name) > :not(.answer-details) {
    max-width: 65%;
    overflow-wrap: anywhere;
  }

  .answers-detail-table .answer-details {
    max-width: 65%;
  }

  .answers-table tbody td.empty-state {
    display: block;
    border: 1px solid #e9ecef;
    border-radius: 0.65rem;
    background: #fff;
    text-align: center;
  }

  .answers-table tbody td.empty-state::before {
    display: none;
  }
}
.answer-details-modal {
  padding: 1.35rem;
  border-radius: 0.85rem;
  background: #f5f7fa;
}

.answer-details-header,
.answer-details-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
}

.answer-details-header {
  margin-bottom: 1.1rem;
}

.answer-details-header-actions,
.answers-section-actions {
  display: flex;
  align-items: center;
  gap: 0.6rem;
}

.answer-details-header-actions .btn,
.answers-section-actions .btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  margin: 0;
  border-radius: 0.55rem;
  font-weight: 650;
  white-space: nowrap;
}

.answer-details-heading {
  justify-content: flex-start;
}

.answer-details-icon {
  display: grid;
  flex: 0 0 44px;
  width: 44px;
  height: 44px;
  place-items: center;
  border-radius: 12px;
  background: #e8f3ed;
  color: #347453;
  font-size: 18px;
}

.answer-details-heading h3 {
  margin: 0.15rem 0;
  color: #27394d;
  font-size: 1.12rem;
  font-weight: 750;
}

.answer-details-heading p {
  margin: 0;
  color: #788696;
  font-size: 0.8rem;
}

.detail-question-count {
  flex: 0 0 auto;
  padding: 0.35rem 0.65rem;
  border: 1px solid #e0e7ed;
  border-radius: 99px;
  background: #fff;
  color: #536579;
  font-size: 0.72rem;
  font-weight: 700;
}

.answer-detail-list {
  display: grid;
  max-height: min(65vh, 680px);
  gap: 0.85rem;
  overflow-y: auto;
  padding: 2px 0.3rem 2px 2px;
}

.answer-detail-card {
  overflow: hidden;
  border: 1px solid #e4e9ee;
  border-radius: 0.75rem;
  background: #fff;
  box-shadow: 0 3px 12px rgba(33, 52, 71, 0.045);
}

.answer-detail-card-heading {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.85rem 1rem;
  border-bottom: 1px solid #edf0f3;
  background: #fbfcfd;
}

.answer-detail-index {
  display: grid;
  flex: 0 0 36px;
  width: 36px;
  height: 36px;
  place-items: center;
  border-radius: 10px;
  background: #eaf3ee;
  color: #347453;
  font-size: 0.78rem;
  font-weight: 800;
  font-variant-numeric: tabular-nums;
}

.answer-detail-question-label {
  display: grid;
  flex: 1;
  gap: 0.1rem;
}

.answer-detail-question-label span {
  color: #7a8998;
  font-size: 0.61rem;
  font-weight: 800;
  letter-spacing: 0.09em;
}

.answer-detail-question-label strong {
  color: #34465a;
  font-size: 0.87rem;
}

.answer-status-pill {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  max-width: 40%;
  padding: 0.3rem 0.55rem;
  border: 1px solid #dce6ed;
  border-radius: 99px;
  background: #f2f7fa;
  color: #456477;
  font-size: 0.68rem;
  font-weight: 700;
  overflow-wrap: anywhere;
}

.answer-status-pill--failed {
  border-color: #f2c9cc;
  background: #fff0f1;
  color: #b4232d;
}

.answer-status-pill--pass {
  border-color: #bfe2ce;
  background: #edf8f1;
  color: #24734b;
}

.answer-detail-field {
  min-width: 0;
  padding: 0.9rem 1rem;
}

.answer-detail-field--question {
  border-bottom: 1px solid #edf0f3;
}

.answer-detail-label {
  display: block;
  margin-bottom: 0.4rem;
  color: #788696;
  font-size: 0.64rem;
  font-weight: 800;
  letter-spacing: 0.07em;
  text-transform: uppercase;
}

.answer-detail-value {
  color: #34465a;
  font-size: 0.88rem;
  line-height: 1.55;
  overflow-wrap: anywhere;
}

.answer-detail-response-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.answer-detail-response-grid > :first-child {
  border-right: 1px solid #edf0f3;
}

.answer-detail-rich >>> p:last-child {
  margin-bottom: 0;
}

.answer-detail-rich >>> img {
  max-width: 100%;
  height: auto;
}

.answer-details-empty {
  display: grid;
  justify-items: center;
  gap: 0.35rem;
  padding: 2.5rem 1rem;
  border: 1px dashed #d8e0e7;
  border-radius: 0.75rem;
  background: #fff;
  color: #7b8998;
  text-align: center;
}

.answer-details-empty i {
  margin-bottom: 0.25rem;
  color: #9aa8b5;
  font-size: 1.5rem;
}

.answer-details-empty strong {
  color: #46596d;
  font-size: 0.9rem;
}

.answer-details-empty span {
  font-size: 0.78rem;
}

.exam-summary {
  margin: 0 0 1.25rem;
  padding: 1.5rem;
  border: 1px solid #e6ebf1;
  border-radius: 0.9rem;
  background: linear-gradient(135deg, #fff 0%, #f7fbf9 100%);
  box-shadow: 0 0.5rem 1.5rem rgba(50, 70, 90, 0.07);
}

.exam-summary-heading,
.answers-section-heading {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
}

.summary-eyebrow {
  color: #478267;
  font-size: 0.67rem;
  font-weight: 800;
  letter-spacing: 0.11em;
}

.exam-summary-heading h1 {
  margin: 0.25rem 0;
  color: #26374a;
  font-size: 1.4rem;
  font-weight: 750;
}

.exam-summary-heading p,
.answers-section-heading p {
  margin: 0;
  color: #778497;
  font-size: 0.86rem;
}

.access-code {
  display: grid;
  gap: 0.2rem;
  min-width: 140px;
  padding: 0.65rem 0.85rem;
  border: 1px solid #dcebe2;
  border-radius: 0.65rem;
  background: #f0f8f3;
}

.access-code span {
  color: #6d8978;
  font-size: 0.61rem;
  font-weight: 800;
  letter-spacing: 0.09em;
}

.access-code strong {
  color: #276647;
  font-size: 1rem;
  letter-spacing: 0.04em;
  overflow-wrap: anywhere;
}

.exam-summary-details {
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  gap: 0.65rem;
  margin-top: 1.25rem;
}

.exam-summary-details > div {
  display: grid;
  gap: 0.2rem;
  min-width: 0;
  padding: 0.75rem;
  border: 1px solid #edf0f3;
  border-radius: 0.65rem;
  background: rgba(255, 255, 255, 0.85);
}

.exam-summary-details span {
  color: #8491a0;
  font-size: 0.68rem;
}

.exam-summary-details strong {
  color: #34465a;
  font-size: 0.82rem;
  overflow-wrap: anywhere;
}

.answers-section-heading {
  align-items: center;
  margin: 0 0 1rem;
}

.answers-section-heading h2 {
  margin: 0 0 0.2rem;
  color: #2c3e50;
  font-size: 1.08rem;
  font-weight: 750;
}

.submission-count {
  flex: 0 0 auto;
  padding: 0.35rem 0.65rem;
  border-radius: 99px;
  background: #edf4f0;
  color: #397356;
  font-size: 0.72rem;
  font-weight: 750;
}

.answers-table-wrap {
  overflow-x: auto;
  overscroll-behavior-x: contain;
}

.answers-table-wrap:not(.answers-detail-table-wrap) .answers-table {
  min-width: 1120px;
  table-layout: auto;
}

.answers-table-wrap:not(.answers-detail-table-wrap) .answers-table th,
.answers-table-wrap:not(.answers-detail-table-wrap) .answers-table td {
  white-space: nowrap;
}

.answers-table-wrap:not(.answers-detail-table-wrap)
  .answers-table
  th:first-child,
.answers-table-wrap:not(.answers-detail-table-wrap)
  .answers-table
  td:first-child {
  min-width: 180px;
}

.answers-table-wrap:not(.answers-detail-table-wrap)
  .answers-table
  th:nth-child(2),
.answers-table-wrap:not(.answers-detail-table-wrap)
  .answers-table
  td:nth-child(2) {
  min-width: 130px;
}

.answers-table-wrap:not(.answers-detail-table-wrap)
  .answers-table
  th:nth-child(4),
.answers-table-wrap:not(.answers-detail-table-wrap)
  .answers-table
  td:nth-child(4),
.answers-table-wrap:not(.answers-detail-table-wrap)
  .answers-table
  th:nth-child(5),
.answers-table-wrap:not(.answers-detail-table-wrap)
  .answers-table
  td:nth-child(5) {
  min-width: 145px;
}

.answers-table-wrap:not(.answers-detail-table-wrap)
  .answers-table
  th:last-child,
.answers-table-wrap:not(.answers-detail-table-wrap)
  .answers-table
  td:last-child {
  min-width: 205px;
}

.answers-table-wrap:not(.answers-detail-table-wrap)
  .answers-table
  .student-name {
  white-space: normal;
}

.answer-actions {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

.answer-actions .btn {
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  gap: 0.5rem;
  width: 100%;
  margin: 0;
  text-align: left;
}

.answers-detail-table-wrap {
  overflow-x: auto;
}

@media (max-width: 991.98px) {
  .exam-summary-details {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

@media (max-width: 767.98px) {
  .answer-details-modal {
    padding: 0.9rem;
  }

  .answer-detail-response-grid {
    grid-template-columns: minmax(0, 1fr);
  }

  .answer-detail-response-grid > :first-child {
    border-right: 0;
    border-bottom: 1px solid #edf0f3;
  }

  .exam-summary {
    padding: 1.1rem;
  }

  .exam-summary-details {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 0.5rem;
  }

  .exam-summary-details > div {
    padding: 0.65rem;
  }

  .answers-section-heading {
    align-items: flex-start;
  }

  .answers-table-wrap:not(.answers-detail-table-wrap) .answers-table {
    min-width: 0;
  }

  .answers-table-wrap:not(.answers-detail-table-wrap) .answers-table th,
  .answers-table-wrap:not(.answers-detail-table-wrap) .answers-table td,
  .answers-table-wrap:not(.answers-detail-table-wrap)
    .answers-table
    th:first-child,
  .answers-table-wrap:not(.answers-detail-table-wrap)
    .answers-table
    td:first-child,
  .answers-table-wrap:not(.answers-detail-table-wrap)
    .answers-table
    th:nth-child(2),
  .answers-table-wrap:not(.answers-detail-table-wrap)
    .answers-table
    td:nth-child(2),
  .answers-table-wrap:not(.answers-detail-table-wrap)
    .answers-table
    th:nth-child(4),
  .answers-table-wrap:not(.answers-detail-table-wrap)
    .answers-table
    td:nth-child(4),
  .answers-table-wrap:not(.answers-detail-table-wrap)
    .answers-table
    th:nth-child(5),
  .answers-table-wrap:not(.answers-detail-table-wrap)
    .answers-table
    td:nth-child(5),
  .answers-table-wrap:not(.answers-detail-table-wrap)
    .answers-table
    th:last-child,
  .answers-table-wrap:not(.answers-detail-table-wrap)
    .answers-table
    td:last-child {
    min-width: 0;
  }

  .answers-table tbody td {
    align-items: flex-start;
    gap: 0.75rem;
    white-space: normal;
  }

  .answers-table tbody td > :not(.answer-actions) {
    max-width: 65%;
    overflow-wrap: anywhere;
  }

  .answers-table tbody td.student-name {
    overflow-wrap: anywhere;
  }

  .answers-table tbody td.student-name > span {
    display: block;
    overflow-wrap: anywhere;
  }

  .answers-table tbody td.actions-cell {
    display: block;
    text-align: left;
  }

  .answers-table tbody td.actions-cell::before {
    display: block;
    margin-bottom: 0.55rem;
  }

  .answer-actions {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .answer-actions .btn {
    justify-content: center;
    min-width: 0;
    padding: 0.45rem 0.35rem;
    white-space: normal;
    text-align: center;
  }

  .answer-actions .btn span {
    overflow-wrap: anywhere;
  }

  .answers-detail-table-wrap {
    overflow: visible;
  }
}

@media (max-width: 420px) {
  .answer-details-header {
    align-items: flex-start;
  }

  .answer-details-header-actions,
  .answers-section-actions {
    flex-wrap: wrap;
    justify-content: flex-end;
  }

  .answer-details-heading {
    align-items: flex-start;
  }

  .answer-details-icon {
    flex-basis: 36px;
    width: 36px;
    height: 36px;
    font-size: 15px;
  }

  .detail-question-count {
    max-width: 90px;
    text-align: center;
  }

  .answer-details-header-actions {
    flex-direction: column;
    align-items: flex-end;
  }

  .answer-detail-card-heading {
    flex-wrap: wrap;
    padding: 0.75rem;
  }

  .answer-status-pill {
    max-width: 100%;
    margin-left: 3.1rem;
  }

  .exam-summary-heading {
    flex-direction: column;
  }

  .access-code {
    width: 100%;
  }

  .answer-actions {
    grid-template-columns: 1fr;
  }
}

.answer-submission-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(min(100%, 350px), 1fr));
  gap: 1rem;
}

.submission-card {
  min-width: 0;
  padding: 1.1rem;
  border: 1px solid #e4eaf0;
  border-radius: 0.85rem;
  background: #fff;
  box-shadow: 0 0.35rem 1.1rem rgba(37, 55, 75, 0.055);
  transition: border-color 0.18s ease, box-shadow 0.18s ease,
    transform 0.18s ease;
}

.submission-card:hover {
  transform: translateY(-2px);
  border-color: #d2dfd8;
  box-shadow: 0 0.65rem 1.4rem rgba(37, 55, 75, 0.09);
}

.submission-card-heading {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  min-width: 0;
}

.student-avatar {
  display: grid;
  flex: 0 0 44px;
  width: 44px;
  height: 44px;
  place-items: center;
  border: 1px solid #d9e9df;
  border-radius: 13px;
  background: #edf7f1;
  color: #347453;
  font-size: 0.84rem;
  font-weight: 800;
  letter-spacing: 0.04em;
}

.submission-student {
  flex: 1;
  min-width: 0;
}

.submission-student h3 {
  margin: 0 0 0.2rem;
  color: #293a4d;
  font-size: 0.98rem;
  font-weight: 750;
  overflow-wrap: anywhere;
}

.submission-student > span {
  color: #7c8998;
  font-size: 0.74rem;
  overflow-wrap: anywhere;
}

.time-spent-badge {
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  gap: 0.4rem;
  padding: 0.4rem 0.55rem;
  border: 1px solid #e7ebef;
  border-radius: 99px;
  background: #f8fafb;
  color: #5a6b7e;
  font-size: 0.72rem;
  font-weight: 700;
}

.time-spent-badge i {
  color: #789080;
}

.submission-metrics {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.55rem;
  margin-top: 1rem;
}

.submission-metric {
  display: grid;
  gap: 0.25rem;
  min-width: 0;
  padding: 0.7rem 0.65rem;
  border: 1px solid #e9edf1;
  border-radius: 0.65rem;
  background: #fafbfc;
}

.submission-metric span {
  color: #7a8796;
  font-size: 0.65rem;
  font-weight: 700;
}

.submission-metric strong {
  color: #37495d;
  font-size: 1.12rem;
  font-variant-numeric: tabular-nums;
  line-height: 1.1;
}

.submission-metric--correct {
  border-color: #dcefe3;
  background: #f3faf5;
}

.submission-metric--correct strong {
  color: #28764d;
}

.submission-metric--incorrect {
  border-color: #f1e2e2;
  background: #fdf7f7;
}

.submission-metric--incorrect strong {
  color: #b3454b;
}

.submission-dates {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.8rem;
  margin-top: 0.95rem;
  padding-top: 0.85rem;
  border-top: 1px solid #edf0f3;
}

.submission-dates > div {
  display: grid;
  gap: 0.3rem;
  min-width: 0;
}

.submission-dates span {
  display: flex;
  align-items: center;
  gap: 0.35rem;
  color: #84909e;
  font-size: 0.65rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.submission-dates span i {
  color: #6e8b7b;
}

.submission-dates strong {
  color: #48596d;
  font-size: 0.75rem;
  font-weight: 650;
  overflow-wrap: anywhere;
}

.submission-actions {
  display: flex;
  gap: 0.6rem;
  margin-top: 1rem;
}

.submission-actions .btn {
  display: inline-flex;
  flex: 1 1 0;
  align-items: center;
  justify-content: center;
  gap: 0.45rem;
  min-width: 0;
  margin: 0;
  padding: 0.55rem 0.65rem;
  border-radius: 0.55rem;
  font-size: 0.75rem;
  font-weight: 650;
  white-space: normal;
}

.submission-empty-state {
  display: grid;
  justify-items: center;
  gap: 0.35rem;
  padding: 3rem 1rem;
  border: 1px dashed #d8e0e7;
  border-radius: 0.85rem;
  background: #fbfcfd;
  color: #7e8b99;
  text-align: center;
}

.submission-empty-icon {
  display: grid;
  width: 46px;
  height: 46px;
  margin-bottom: 0.35rem;
  place-items: center;
  border-radius: 14px;
  background: #eef2f5;
  color: #81909e;
  font-size: 1.15rem;
}

.submission-empty-state strong {
  color: #46596d;
  font-size: 0.92rem;
}

.submission-empty-state > span:last-child {
  font-size: 0.8rem;
}

@media (max-width: 575.98px) {
  .answer-submission-grid {
    grid-template-columns: minmax(0, 1fr);
    gap: 0.75rem;
  }

  .submission-card {
    padding: 0.9rem;
  }

  .submission-card-heading {
    flex-wrap: wrap;
  }

  .submission-actions {
    flex-direction: column;
  }

  .submission-actions .btn {
    width: 100%;
  }
}
</style>
